interface AgentProfileSectionsProps {
    agent: {
        description?: string | null
        function_description?: string | null
    }
}

export function AgentProfileSections({ agent }: AgentProfileSectionsProps) {
    return (
        <div className="px-4 md:px-4 space-y-4 pb-8">
            {/* Sobre */}
            {agent.description && (
                <div className="bg-white dark:bg-black rounded-2xl p-6 border border-gray-200 dark:border-gray-800">
                    <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                        Sobre
                    </h2>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        {agent.description}
                    </p>
                </div>
            )}

            {/* Função/Cargo */}
            {agent.function_description && (
                <div className="bg-white dark:bg-black rounded-2xl p-6 border border-gray-200 dark:border-gray-800">
                    <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                        Função / Cargo
                    </h2>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        {agent.function_description}
                    </p>
                </div>
            )}
        </div>
    )
}
